// extracted by mini-css-extract-plugin
export default {"squareValue":"Theme_squareValue__JiIzA"};